module.exports = __webpack_public_path__ + "img/-s-icon03.77ce0cc8.png";